<template>
  <div>
    <topup-progress />
    <topup-stage1 v-if="isStageActive(1)" />
    <topup-stage2 v-if="isStageActive(2)" />
    <topup-stage3 v-if="isStageActive(3)" />
  </div>
</template>

<script>
import TopupProgress from '../components/Topup/Single/Progress'
import TopupStage1 from '../components/Topup/Single/Stage1'
import TopupStage2 from '../components/Topup/Single/Stage2'
import TopupStage3 from '../components/Topup/Single/Stage3'
import TopupSingleMixin from '@/common/mixins/views/TopupSingle.mixin'

export default {
  name: 'SingleTopupView',
  mixins: [TopupSingleMixin],
  components: {
    TopupProgress,
    TopupStage1,
    TopupStage2,
    TopupStage3
  }
}
</script>
